// Constants and Utils
import {
  formatText,
  toLocaleString,
} from "../../../common-utils/string-utils/StringUtils";
import { getOtsTotal } from "../../../utils/mavinMetrics";
import {
  checkAnyValuePresentForKeys,
  constructCityImpressionsSplit,
} from "../GraphReportsUtils";
import { ImpressionsSplitBarDataKeys } from "../GraphReportsConstants";

// Components
import { BarChart } from "../../../components/charts/Charts";
import TableHeaders from "../../../components/table/TableHeaders";
import { NoChartDataMessage } from "../GraphReportUtils";

// Page Constants
const tableHeaders = [
  {
    title: {
      displayName: "City",
      className: "col-4 text-center",
    },
  },
  {
    title: {
      displayName: "Impressions",
      className: "col-4 text-center",
    },
  },
  {
    title: {
      displayName: "TG Impressions",
      className: "col-4 text-center",
    },
  },
];

// Impressions Split Table Section
function ImpressionsSplitTableSection({
  infoByCity = {},
  targetGroupId,
  isCustomTgSelected = false,
}) {
  // final tg select check
  const isAnyTgSelected = targetGroupId || isCustomTgSelected;

  return (
    <div className="col-5 table-responsive max-h-400 thick-scrollbar">
      <table className="table">
        {/* Table- Header */}
        <TableHeaders requiredSubHeader={false} tableHeaders={tableHeaders} />

        <tbody>
          {Object.values(infoByCity).map((cityInfo) => {
            const { cityName, cityId } = cityInfo;
            const { otsTotal, tgOtsTotal } = getOtsTotal(cityInfo);

            // final tgOtsString
            const finalTgOtsTotalStr = isAnyTgSelected
              ? formatText(toLocaleString(tgOtsTotal))
              : `NA`;

            return (
              <tr key={cityId}>
                <td className="text-center text-primary">{cityName}</td>
                <td className="text-center">
                  {formatText(toLocaleString(otsTotal))}
                </td>
                <td className="text-center">{finalTgOtsTotalStr}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
}

// Impressions Split Graph Section
function ImpressionsSplitGraphSection({ infoByCity = {} }) {
  // impressions Split Data
  const impressionsSplitData = constructCityImpressionsSplit(infoByCity);

  // check for data
  const hasImpSplitDataForAnyCity = checkAnyValuePresentForKeys(
    impressionsSplitData,
    ImpressionsSplitBarDataKeys
  );

  return (
    <div className="col-7">
      <h4 className="font-weight-bold pr-2 mb-0">
        City Wise Impressions V/s TG-Impressions Split
      </h4>

      {/* bar chart */}
      <div className="px-4 pt-4">
        {!hasImpSplitDataForAnyCity && (
          <NoChartDataMessage message="Impressions Split Not Present For Any City" />
        )}
        {hasImpSplitDataForAnyCity && (
          <BarChart
            data={impressionsSplitData}
            barsData={ImpressionsSplitBarDataKeys}
            showCartesianGrid={true}
            showCustomXAxisTick={true}
          />
        )}
      </div>
    </div>
  );
}

/**
 * Campaign Impressions Split Section
 */
export default function CampaignImpressionsSplitSection({
  infoByCity = {},
  targetGroupId,
  isCustomTgSelected = false,
}) {
  return (
    <div className="row py-4 border-bottom">
      {/* graph */}
      <ImpressionsSplitGraphSection infoByCity={infoByCity} />

      {/* Table */}
      <ImpressionsSplitTableSection
        infoByCity={infoByCity}
        targetGroupId={targetGroupId}
        isCustomTgSelected={isCustomTgSelected}
      />
    </div>
  );
}
